import { createFileRoute } from '@tanstack/react-router'
import ClerkSignUp from '@/features/auth/sign-up/clerk-sign-up'

export const Route = createFileRoute('/(auth)/sign-up')({
  component: ClerkSignUp,
})
